<cc-script-loader [scriptParams]="scriptParams">
  <!--
    see https://confluence.mercedes-benz.io/x/sLZBDQ
    event 'fcis_rawResponse' is the same as 'fcis_quote' with the difference that we get not just the output container
    but the parent object with more details (including 'input' and 'opaque' what we need for the rate calculation)

    We set the environment hard-coded to production as default value in order to help solving issues with PLS and the purchasePrice
  -->
  <cc-shadow-dom-wrapper [style.display]="isWidgetVisible ? 'inline' : 'none'">
    <fcis-widget
      #fcisWidget
      [attr.environment]="'production'"
      (fcis_rawResponse)="onFcisCalculationResult($event)"
      (fcis_error)="onFcisError($event)"
      (fcis_button_click)="onFcisButtonClick()"
      parent-application-id="owcc"
    />
  </cc-shadow-dom-wrapper>
</cc-script-loader>
